module.exports = __webpack_public_path__ + "img/Sarah.676a7f92.gif";